import { useEffect, useState } from "react";

import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  Grid,
} from "@material-ui/core";

import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import HeaderClientes from "components/_refactor/headers/clients";
import StructureFields from "components/_refactor/fields/structure";
import ConfigurableCustomerContactMethod from "./components/card-config-contact-method";
import Api from "lib/api/httpRequestHelper";
import { IsMobile } from "utils/is-mobile";

export default function ConfiguracoesTemplateOmnichat() {
  const snackbar = useSnackbar();

  const isMobile = IsMobile();

  const [sellerList, setSellerList] = useState([]);
  const [seller, setSeller] = useState("");
  const [structureFilters, setStructureFilters] = useState({});
  const [structureFiltersLoading, setStructureFiltersLoading] = useState(false);
  const [scheduleList, setScheduleList] = useState([]);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [templateOptions, setTemplateOptions] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [campainsOptions, setCampaignsOptions] = useState([]);
  const [selectedCampaign, setSelectedCampain] = useState(null);

  const [acept, setAcept] = useState(false);
  const [template, setTemplate] = useState(null);
  const [variables, setVariables] = useState({});
  const [isSaving, setIsSaving] = useState(false);

  const templateVariableCount =
    selectedTemplate?.text.match(/{{\d+}}/g)?.length || 0;

  const [isFetchingTemplate, setIsFetchingTemplate] = useState(false);
  const [isLoadingSellers, setIsLoadingSellers] = useState(false);
  const [isLoadingSchedules, setIsLoadingSchedules] = useState(false);
  const [isLoadingTemplates, setIsLoadingTemplates] = useState(false);
  const [isLoadingCampaigns, setIsLoadingCampaigns] = useState(false);

  const handleGetSellerList = async () => {
    setIsLoadingSellers(true);
    const storeId = structureFilters.idLojaUnica;

    await Api.get("seller-list", "action", `?IdPessoaLoja=${storeId}`, true)
      .then((resp) => {
        if (resp?.Success) {
          if (resp?.Result?.ListaVendedores?.length === 0) {
            snackbar.showMessage(
              "Nenhum vendedor localizado. Faça a busca novamente",
              {
                severity: "success",
              }
            );
          } else {
            setSellerList(resp?.Result?.ListaVendedores);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        snackbar.showMessage(error, {
          severity: "error",
        });      })
      .finally(() => setIsLoadingSellers(false));
  };

  const handleGetScheduleList = async () => {
    setIsLoadingSchedules(true);
    const storeId = structureFilters.idLojaUnica;
    await Api.get(
      "schedule-list",
      "action",
      `?IdPessoaLoja=${storeId}&IdVendedor=${seller?.IdLojaVendedorAction}`,
      true
    )
      .then((resp) => {
        if (resp?.Success) {
          if (resp?.Result?.length === 0) {
            snackbar.showMessage(
              "Nenhuma agenda localizada. Faça a busca novamente",
              {
                severity: "success",
              }
            );
          } else {
            setScheduleList(resp?.Result);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        snackbar.showMessage(error, {
          severity: "error",
        });      })
      .finally(() => setIsLoadingSchedules(false));
  };

  const handleUpdateTemplateVariables = async () => {
    try {
      setIsSaving(true);
      const storeId = structureFilters.idLojaUnica;
      if (!template?.IdTemplateAgenda) {
        await Api.post(
          "schedule-template-create",
          "action",
          {
            idTemplate: selectedTemplate.objectId,
            idPessoaLoja: storeId,
            idAgenda: selectedSchedule?.Id,
            idCampanha: selectedCampaign?.Id,
            jsonEstrutura: variables,
          },
          true
        );
      } else {
        await Api.put(
          "schedule-template-edit",
          "action",
          {
            idTemplateAgenda: template.IdTemplateAgenda,
            idTemplate: selectedTemplate.objectId,
            idCampanha: selectedCampaign?.Id,
            jsonEstrutura: variables,
          },
          true
        );
      }
      snackbar.showMessage("Template atualizado com sucesso", {
        severity: "success",
      });
      setStructureFilters({});
      setSeller(null);
      setSelectedSchedule(null);
      setSelectedTemplate(null);
      setVariables({});
      setSelectedCampain(null);
      getTemplates();
    } catch (error) {
      console.log(error);
      snackbar.showMessage(
        error?.response?.data?.ErrorMessage ||
          "Não foi possiver salvar configuração",
        {
          severity: "error",
        }
      );
    } finally {
      setIsSaving(false);
    }
  };

  const getTemplates = async () => {
    try {
      setIsLoadingTemplates(true);
      const response = await Api.get("get-omni-template", "action", "", true);

      setTemplateOptions(response.Result.ListaTemplate);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoadingTemplates(false);
    }
  };

  const getCampaigns = async () => {
    try {
      setIsLoadingCampaigns(true);
      const response = await Api.get("get-omni-campaign", "action", "", true);

      setCampaignsOptions(response.Result.ListaCampanha);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoadingCampaigns(false);
    }
  };

  useEffect(() => {
    getTemplates();
  }, []);

  useEffect(() => {
    if (structureFilters.idLojaUnica) {
      handleGetSellerList();
    }
  }, [structureFilters.idLojaUnica]);

  useEffect(() => {
    if (seller) {
      handleGetScheduleList();
    }
  }, [seller]);

  useEffect(() => {
    if (!selectedSchedule) return;

    setSelectedTemplate(null);
    setVariables({});
    const getTemplateForSchedule = async () => {
      setIsFetchingTemplate(true);
      const storeId = structureFilters.idLojaUnica;
      Api.get(
        "schedule-template-detail",
        "action",
        `?idAgenda=${selectedSchedule.Id}&idPessoaLoja=${storeId}`,
        true
      )
        .then((res) => {
          if (res?.Result?.length > 0) {
            const template = res.Result[0];
            setTemplate(template);

            setSelectedTemplate(
              templateOptions?.find(
                (item) => item.objectId === template.IdTemplate
              )
            );
            setVariables(JSON.parse(template.JsonEstrutura || "{}"));
          }
        })

        .finally(() => setIsFetchingTemplate(false));
    };

    getTemplateForSchedule();
  }, [selectedSchedule]);

  useEffect(() => {
    if (selectedTemplate) {
      getCampaigns();
    }
  }, [selectedTemplate]);

  useEffect(() => {
    if (structureFilters.idLojaUnica) {
      handleGetSellerList();
    }
  }, [structureFilters.idLojaUnica]);

  useEffect(() => {
    if (seller) {
      handleGetScheduleList();
    }
  }, [seller]);

  return (
    <>
      <HeaderClientes
        section="Configurações Omnichat"
        subsection="Administração"
      />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <Grid container spacing={2} style={{ marginBottom: "2rem" }}>
          <Grid item xs={12}>
            <Card>
              <CardHeader
                title="Configurações"
                titleTypographyProps={{
                  component: Box,
                  marginBottom: "0!important",
                  variant: "h3",
                }}
              />
              <CardContent>
                <Grid container spacing={2} alignItems="center">
                  <StructureFields
                    onStructureFieldsChange={setStructureFilters}
                    disableAll={false}
                    onStructureFieldsLoad={setStructureFiltersLoading}
                    requiredFields={["economicGroup", "singleStore"]}
                    hideFields={["brand", "channel", "representative", "store"]}
                    showSingleStore={true}
                  />

                  <Grid item xs={12}>
                    <AutoCompleteField
                      options={sellerList}
                      label="Vendedor"
                      onChange={setSeller}
                      disabled={!structureFilters.idLojaUnica}
                      loading={isLoadingSellers}
                      value={seller}
                      optionIdKey="IdLojaVendedorAction"
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <AutoCompleteField
                      options={scheduleList}
                      label="Agenda"
                      onChange={setSelectedSchedule}
                      value={selectedSchedule}
                      loading={isLoadingSchedules}
                      disabled={!seller}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <AutoCompleteField
                      options={templateOptions}
                      label="Template"
                      value={selectedTemplate}
                      onChange={(value) => {
                        setSelectedTemplate(value);

                        if (value?.objectId === template?.IdTemplate) {
                          setVariables(
                            JSON.parse(template?.JsonEstrutura || "{}")
                          );
                        } else {
                          setVariables({});
                        }
                      }}
                      loading={isLoadingTemplates}
                      optionLabelKey="title"
                      optionIdKey="objectId"
                      disabled={isSaving || !selectedSchedule}
                    />

                    {Array.from({ length: templateVariableCount }).map(
                      (_, index) => {
                        return (
                          <AutoCompleteField
                            key={index}
                            label={`{{${index + 1}}}`}
                            value={{
                              label: variables[index + 1],
                              value: variables[index + 1],
                            }}
                            disabled={isSaving}
                            onChange={(option) => {
                              setVariables((variables) => ({
                                ...variables,
                                [index + 1]: option?.value,
                              }));
                            }}
                            options={[
                              {
                                label: "Nome",
                                value: "Nome",
                              },
                              {
                                label: "NomeCompleto",
                                value: "NomeCompleto",
                              },

                              {
                                label: "CrmBonus",
                                value: "CrmBonus",
                              },
                              {
                                label: "ExpiracaoCrmBonus",
                                value: "ExpiracaoCrmBonus",
                              },
                            ]}
                            optionLabelKey="label"
                            optionIdKey="value"
                          />
                        );
                      }
                    )}
                  </Grid>

                  <Grid item xs={12}>
                    <Button
                      style={
                        isMobile
                          ? {
                              width: "100%",
                              marginBottom: "0.75rem",
                              marginTop: "0.75rem",
                            }
                          : { marginBottom: "0rem" }
                      }
                      variant="contained"
                      disabled={
                        isSaving ||
                        isFetchingTemplate ||
                        structureFiltersLoading.length > 0
                      }
                      onClick={handleUpdateTemplateVariables}
                    >
                      {isSaving ? "Atualizando..." : "Atualizar"}
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          <ConfigurableCustomerContactMethod
            title="Link de Pagamento"
            templateOptions={templateOptions}
            type="LK"
          />
          <ConfigurableCustomerContactMethod
            title="Cliente 360"
            templateOptions={templateOptions}
            type="C360"
          />
          <ConfigurableCustomerContactMethod
            title="Vitrine Virtual"
            templateOptions={templateOptions}
            type="VITRINE"
          />
          <ConfigurableCustomerContactMethod
            title="Compartilhamento Nota Fiscal"
            templateOptions={templateOptions}
            type="CNF"
          />
          <ConfigurableCustomerContactMethod
            title="Template PIX Copia e Cola"
            templateOptions={templateOptions}
            type="PIX"
          />
          <ConfigurableCustomerContactMethod
            title="Template TEF"
            templateOptions={templateOptions}
            type="TEF"
          />
        </Grid>
      </Container>
    </>
  );
}
